export default "__VITE_ASSET__DtHdx6cg__"